import { DashboardLayout } from "@/components/dashboard/dashboard-layout";
import ArchivedLocationList from "./ArchivedLocationList";

export default function ArchivedLocationsPage() {
  return (
    <DashboardLayout activeTab="clients">
      <ArchivedLocationList />
    </DashboardLayout>
  );
}
